<template>
  <el-dialog :title="title" :visible.sync="userDialog" width="30%" :before-close="cancel">
    <div>
      <el-form ref="userForm" :model="form" :rules="rules" label-width="80px" size="mini">
        <el-form-item label="用户名" prop="loginName">
          <el-input v-model="form.loginName" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="mobile">
          <el-input v-model="form.mobile" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" auto-complete="new-password" v-model="form.password" placeholder="请输入密码（如不修改则不填写）"></el-input>
        </el-form-item>
        <!-- <el-form-item label="部门" prop="officeData">
          <el-select v-model="officeData" placeholder="请选择部门">
            <el-option
              v-for="item in officeOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色" prop="roleData">
          <el-select v-model="roleData" multiple placeholder="请选择角色">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="userDialog = false">取 消</el-button>
      <el-button type="primary" @click="submit('userForm')">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { rolesApi, userAddApi, userPutApi, userOneApi, officeListApi } from "@/api/api";
import { vaPhone, vaEmail } from "@/api/Reg";

export default {
  name: "",
  data() {
    return {
      form: {},
      officeData:"",
      officeOptions:[],//部门列表
      userDialog: false,
      roleData:[],
      options: [], //角色列表
      rules: {
        loginName: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        mobile: [
          { required: true, validator:vaPhone,trigger: "blur" }
        ]
      }
    };
  },
  props: {
    title: { type: String }
  },
  methods: {
    init(res) {
      this.officeData = "";
        this.roleData = [];
      //获取角色列表
      rolesApi().then(res => {
        this.options = res;
      });
      //获取部门列表
      officeListApi().then(res => {
        this.officeOptions = res;
      });
      if (res) {
        //获取用户详情
        userOneApi(res.id).then(res => {
          //回显部门，角色数据
          this.officeData = res.office?res.office.id:"";
          if(res.roles) {
            res.roles.forEach(element => {
              this.roleData.push(element.id);
            });
          }
          this.form = res;
        });
        
      } else {
        //清空数据
        this.form = {
          id: "",
          loginName: "",
          mobile: "",
          email: "",
          roles:[],
          office:{
            id:""
          }
        };
      }
      this.userDialog = true;
    },
    cancel() {
      this.userDialog = false;
    },
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // this.form.office.id = this.officeData;
          // this.form.roles = [];
          // this.roleData.forEach(element => {
          //   var obj = {
          //     id:element
          //   }
          //   this.form.roles.push(obj);
          // })
          if (this.form.id) {
            this.update();
          } else {
            this.add();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    update() {
      let {
        form,
        cancel,
        $parent
      } = this;
      userPutApi(form).then(res => {
        elMsg("修改成功");
        cancel();
        $parent.init();
      });
    },
    add() {
      let { form, cancel, $parent } = this;
      userAddApi(form)
        .then(res => {
          
          elMsg("新增成功");
          cancel();
          $parent.init();
          
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang='less' scoped>
.tree_box {
  border: 1px solid #dcdfe6;
  padding: 6px;
}
.tree_box span {
  margin: 0 3px;
}
</style>